import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

const filter = createFilterOptions();

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/* 	InputField
 *	@params id 			string	 	identificador input
 * 	@params label 		string  	label input
 *	@params value		any type	value input
 *	@params disabled	bool		disabled input
 *	@params error		bool 		enable class error
 *	@params helperText	string 		helper text
 *	@params onChange	function 	function change
 *	@params InputProps	Object
 *	More Information https://material-ui.com/es/api/text-field/
 */

// FIXME: Fix the error in the filter function
// const filter = createFilterOptions();

const AutocompleteField = ({
  id,
  className,
  optionAdd = false,
  label,
  limitTags = 2,
  multiline,
  name,
  multiple,
  placeholder,
  value,
  loading,
  variant = 'standard',
  error,
  disabled,
  helperText,
  onChange,
  InputProps,
  options,
  groupBy,
  onBlur, 
  ...props
}) => {
  return (
    <FormControl variant='standard' fullWidth error={!!error}>
      {/* {label && <InputLabel shrink>{label}</InputLabel>} */}
      <Autocomplete
        id={id}
        value={value ? value : multiple ? [] : ''}
        name={name}
        options={options}
        fullWidth
        groupBy={groupBy}
        disabled={disabled}
        loading={loading}
        onChange={(event, newValue) => {
          if (onChange) {
            if (typeof newValue === 'string') {
              onChange({
                value: newValue,
                label: newValue
              });
            } else if (newValue && newValue.inputValue) {
              // Create a new value from the user input
              onChange({
                value: newValue.inputValue,
                label: newValue.inputValue
              });
            } else {
              onChange(newValue);
            }
          }
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);
          const { inputValue } = params;
          // Suggest the creation of a new value
          const isExisting = options.some((option) => inputValue === option.label);
          if (optionAdd && inputValue !== '' && !isExisting) {
            filtered.push({
              inputValue,
              label: `Add "${inputValue}"`
            });
          }

          return filtered;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        getOptionLabel={(option) => {
          if (typeof option === 'string') {
            return option;
          }
          return option?.label || '';
        }}
        getOptionDisabled={(option) => option.disabled}
        autoSelect
        multiple={multiple}
        limitTags={limitTags}
        size='small'
        className={className}
        ListboxProps={{
          className
        }}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField
            size='small'
            {...params}
            label={label}
            variant={variant}
            placeholder={placeholder}
            multiline={multiline}
            error={!!error}
            onBlur={onBlur}
            InputProps={{
              className,
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  <div className='m-r-20 box-end'>
                    {loading ? <FontAwesomeIcon className='text-grey-dark' icon='circle-notch' spin /> : null}
                    {params.InputProps.endAdornment}
                  </div>
                </React.Fragment>
              )
            }}
          />
        )}
        {...props}
      />
      {helperText && (
        <FormHelperText className='m-0' error={!!error}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default React.memo(AutocompleteField);
